<script setup lang="ts">
import { ref } from 'vue';
import { DgrIcon } from '@stockmarkteam/donguri-ui';
import { MentionItem } from '@/types';

interface Props {
  top?: number;
  left?: number;
  zIndex?: string | number;
  mentionList?: MentionItem[];
  activeIndex?: number;
}

const props = withDefaults(defineProps<Props>(), {
  top: () => 0,
  left: () => 0,
  mentionList: () => [],
  activeIndex: () => 0,
});

type Emits = {
  'on-item-selected': [value: number];
  'on-mouse-enter': [value: number];
};

const emit = defineEmits<Emits>();

const mentionArea = ref<HTMLElement>();

const fixScrollTop = () => {
  if (!mentionArea.value) return;
  const itemHeight = 35;
  const offsetFromTop = 100;
  mentionArea.value.scrollTop =
    (props.activeIndex - 1) * itemHeight - offsetFromTop;
};

defineExpose({
  fixScrollTop,
});
</script>

<template>
  <ul
    ref="mentionArea"
    class="mention-list-mount-point"
    :style="{ top: top + 'px', left: left + 'px', zIndex }"
  >
    <li
      v-for="(mentionItem, index) in mentionList"
      :key="mentionItem.key"
      class="mention-list-item"
      :class="{ selected: activeIndex === index }"
      @click="emit('on-item-selected', index)"
      @mouseenter="emit('on-mouse-enter', index)"
    >
      <DgrIcon
        size="small"
        :name="mentionItem.iconName"
        :keep-fill="false"
      /><span class="title c-title-bold--m">{{
        mentionItem.textInComment
      }}</span
      ><span class="subtitle c-text-regular--s">{{
        mentionItem.textInCandidateList
      }}</span>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
.mention-list-mount-point {
  background-color: white;
  width: 420px;
  max-height: 198px;
  margin: 4px 0 8px 1px;
  background: #ffffff;
  overflow: auto;
  box-shadow: 0px 1px 3px rgba(74, 74, 74, 0.4);
  border-radius: 4px;
  z-index: var(--z-dropdown);
}

.mention-list-item {
  display: flex;
  justify-content: start;
  align-items: baseline;
  padding: 6px 16px;
  cursor: pointer;
  color: $color-gray1000;
  white-space: nowrap;

  .title {
    margin: 0 8px;
  }

  .subtitle {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .icon-box {
    flex-shrink: 0;
    .active {
      color: $color-green600;
    }
  }

  &.selected {
    background-color: $color-green100;
    color: $color-green600;
    .icon-box {
      color: $color-green600;
    }
  }
}
</style>
